import { request } from '@umijs/max';

export interface StorageCryptoKeyRegistryItem {
  mode: 'standard' | 'gm';
  keyId: string;
  algorithm: string;
  keyMaterial: string;
  ivMaterial?: string;
  isCurrent: number;
}

const extractList = (res: any): StorageCryptoKeyRegistryItem[] => {
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.data)) return res.data;
  if (Array.isArray(res?.list)) return res.list;
  if (Array.isArray(res?.data?.list)) return res.data.list;
  return [];
};

export async function getStorageCryptoKeyRegistry(appUuid?: string) {
  const res = await request('/api/storage/crypto-keys/registry', {
    method: 'POST',
    data: { appUuid: appUuid || '' },
  });
  return extractList(res);
}
